import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IMasterDataState {
  masterDataDetail: IObjectState<any>
}

export const prefix = "masterdata/masterdata"

export const state = (): IMasterDataState => ({
  masterDataDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state.masterDataDetail.data || {}
  },
}

export const mutations = {
  updateDetail: (state: IMasterDataState, data) => {
    Vue.set(state, "masterDataDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.masterDataDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.masterDataDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.masterDataDetail,
          e.response?.data || e
        )
      )
    }
  },
}
